module.exports = __webpack_public_path__ + "graphics/10.ckh.b6aeb62f32a6ea239f39df63956df0b5.png";